import RailsAjax from "../shared/rails-ajax";

const CHECK_PERIOD_IN_MS = 15000;
const WARNING_MARGIN_IN_MS = 60000;

document.addEventListener("DOMContentLoaded", function () {
  let timeoutTargetPath =
    document.querySelector("body").dataset.timeoutTargetPath;
  let timeoutRedirectPath =
    document.querySelector("body").dataset.timeoutRedirectPath;
  let timeoutWarningElement = document.getElementById("timeout-warning");

  if (timeoutTargetPath == null || timeoutWarningElement == null) {
    return;
  }

  timeoutWarningElement
    .querySelector("[data-mdc-dialog-action='cancel']")
    .addEventListener("click", keepAuthenticated);
  timeoutWarningElement
    .querySelector(".logout")
    .addEventListener("click", logout);

  setTimeout(checkForAuthTimeout, CHECK_PERIOD_IN_MS);

  function checkForAuthTimeout() {
    fetch(timeoutTargetPath, { headers: { "devise.skip_trackable": true } })
      .then(function (response) {
        return response.json();
      })
      .then(warnOfAuthTimeout)
      .catch(logout);
  }

  function warnOfAuthTimeout(result) {
    if (result.timeout_at != null) {
      let timeoutAt = new Date(result.timeout_at);

      if (
        timeoutAt - new Date() < WARNING_MARGIN_IN_MS &&
        document.querySelector(".mdc-dialog--open #timeout-warning") === null
      ) {
        document.getElementById("dialog-trigger").click();
      }

      setTimeout(checkForAuthTimeout, CHECK_PERIOD_IN_MS);
    } else {
      redirect();
    }
  }

  function keepAuthenticated() {
    let xhr = RailsAjax.post(timeoutTargetPath, {});
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        if (
          document.querySelector(".mdc-dialog--open #timeout-warning") !== null
        ) {
          document.getElementById("dialog-trigger").click();
        }
      }
    };
  }

  function logout() {
    let xhr = RailsAjax.delete(timeoutTargetPath, {});
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        redirect();
      }
    };
  }

  function redirect() {
    location.replace(timeoutRedirectPath);
  }
});

//  Copyright © 2018 by Northwestern University. All Rights Reserved.
